/** When your routing table is too long, you can split it into small modules **/

// import Layout from '@/layout'

const buildsRouter = {
    path: '/',
    component: () => import('@/views/base/Index'),
    children: [
      {
        name: '建设主体',
        path: 'builds',
        component: () => import('@/views/builds/List'),
      },
      {
        name: '建设主体详情',
        path: 'builds/:id',
        component: () => import('@/views/builds/Details'),
      },
      {
        name: '物业费详情',
        path: 'builds/property/:id',
        component: () => import('@/views/builds/Contracts'),
      },
    ],
  }
  
  export default buildsRouter
  
  
  
  